import { getHnBApi, getOfferDetailsApi, getPropertyOffer, hnbOfferApi, placeCounterOffer } from "@/api/offers";
import { offerEmd } from "@/api/placeOffer";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
import { useEffect } from "react";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { ShimmerContentBlock } from "react-shimmer-effects";
import { toast } from "react-toastify";

const CounterOffer = ({ show, handleClose, type, id,item ,setReload}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sellerContributions, setSellerContributions] = useState([]);
  const [newContribution, setNewContribution] = useState({
    contributionDesc: "",
    contributionAmount: "",
    additionalNote: "",
    contributionType:""
  });
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState({});
  const [offerAmount, setOfferAmount] = useState("");
  const [deposit, setDeposite] = useState("");
  const [closingDays, setClosingDays] = useState("");
  const [validFor, setValidFor] = useState("");
  const [technologyFee, setTechnologyFee] = useState("");
  const [isOfferAmountFocused, setIsOfferAmountFocused] = useState(false);
  const [isDepositFocused, setIsDepositFocused] = useState(false);
  const [isAmountFocused, setIsAmountFocused] = useState(false);
  const [showDelete, setShowDelete] = useState("");
  const [contingencyList, setContingencyList] = useState(data?.contingencyList || []);



  const handleAddContribution = () => {
    trackButtonClick({
      eventName: "contribution_add_confirm",
      eventCategory: "My Offers",
      eventSource: "on add button click",
      eventLabel: `Offer Id - ${id}`,
      eventParams: { offer_type: type },
    });

    const { contributionDesc, contributionAmount,contributionType } = newContribution;

    if (!contributionDesc || !contributionAmount || isNaN(contributionAmount) || Number(contributionAmount) <= 0) {
      setShowError(true);
      return;
    }
    if (contributionType === "SCC") {
      if (error.amount) {
        return;
      }
      validateField("amount", contributionAmount, contributionType);
    }

    setSellerContributions([...sellerContributions, newContribution]);
    setNewContribution({ contributionDesc: "",
    contributionAmount: "",
    additionalNote: "",
    contributionType:""});
    setShowError(false);
  };

  const handleRemoveContribution = (index) => {
     trackButtonClick({
       eventName: "contribution_delete_confirm",
       eventCategory: "My Offers",
       eventSource: "on yes click",
       eventLabel: `Offer Id - ${id}`,
       eventParams: { offer_type: type },
     });

     setShowDelete("");
     const updated = [...sellerContributions];
     updated.splice(index, 1);
     setSellerContributions(updated);
  };

  const renderDays = (min, max, text) => {
    return Array.from({ length: max - min + 1 }, (_, index) => min + index).map(
      (day) => (
        <option key={day} value={day}>
          {day} {text}
        </option>
      )
    );
  };

  const validateField = (field, value, type) => {
    let message = "";

    switch (field) {
      case "offerAmount":
        if (!value || isNaN(value) || Number(value) <= 0) {
          message = "Enter a valid Offer amount";
        } else if (value > data?.maxCounterAmount) {
          message = `Offer Amount must be between ${formatCurrency(
            data?.minCounterAmount
          )} and ${formatCurrency(data?.maxCounterAmount)}`;
        } else if (value < data?.minCounterAmount) {
          message = `Offer Amount must be between ${formatCurrency(
            data?.minCounterAmount
          )} and ${formatCurrency(data?.maxCounterAmount)}`;
        }
        break;

      case "deposit":
        if (!value || isNaN(value) || Number(value) <= 0) {
          message = "Enter a valid Offer Deposit";
        } else if (value > data?.maxOfferDeposit) {
          message = `Deposit Amount must be between ${formatCurrency(
            data?.minOfferDeposit
          )} and ${formatCurrency(data?.maxOfferDeposit)}`;
        } else if (value < data?.minOfferDeposit) {
          message = `Deposit Amount must be between ${formatCurrency(
            data?.minOfferDeposit
          )} and ${formatCurrency(data?.maxOfferDeposit)}`;
        }
        break;

      case "closingDays":
        if (!value) {
          message = "Enter a valid closing Date";
        }
        break;

      case "validFor":
        if (!value) {
          message = "Enter a valid Expiry Days";
        }
        break;

      case "amount":
        if (type === "SCC" && data?.maxClosingCost) {
          if (Number(value) > data?.maxClosingCost) {
            message =
              `The seller has indicated a maximum Closing cost credit of ${data?.maxClosingCost}`;
          }
        }
        if(type==="REP" &&data?.maxRepairCost ){

          if (Number(value) > data?.maxRepairCost) {
            message =
              `The seller has indicated a maximum Repair cost credit of ${data?.maxRepairCost}`;
          }
        }
      default:
        break;
    }

    setError((prev) => ({ ...prev, [field]: message }));
  };
  const counterOffer = async () => {
    try {
      setReload(false)
      const hasFinancing = contingencyList?.some(
  (item) => item.contingencyType === "FINANCING"
);

const filteredContingencyList = hasFinancing
  ? contingencyList
  : contingencyList?.filter((item) => item.contingencyType !== "FINANCING");

      if (validateAll()) {
      const payload = {
        offerId: id,
        counterAmount: offerAmount,
        offerDeposit: deposit,
        closingDays: Number(closingDays),
        sellerContributionList: sellerContributions,
        offerExpiryDays: Number(validFor),
       contingencyList: filteredContingencyList?.map((item) => ({
    comment: item.comment,
    expiryDays: item.expiryDays ?? null,
    contingencyType: item.contingencyType,
  })) || [],
      };
      const wj = item?.activeOffer?.offerId;
      const payload1 = {
        offerId: item?.activeOffer?.offerId,
        activeOffer: item?.activeOffer?.offerId,
        propertyId: item?.propertyDetail?.propertyId,
        buyerDetail: `${item?.buyerDetail?.emailId}|${item?.buyerDetail?.firstName}|${item?.buyerDetail?.lastName}`,
      };
      const counterData = await placeCounterOffer(payload);
      if(counterData?.status==="SUCCESS")
      {
          const resp = await getPropertyOffer({ id:wj, payload:payload1 });
      if(resp.status === "SUCCESS"){
        trackApiCall({
          eventName: "counter_offer_success",
          eventCategory: "My Offers",
          eventSource: "on confirm click success",
          eventLabel: `Offer Id: ${id}`,
        })
        handleClose()
          toast.success("Offer was countered Successfully");
          setReload(true)
} else{
        console.error(resp,'error while submitting');
         setReload(false)

      }     }else{
        console.error(counterData,'error while submitting');
         setReload(false)

      }
    }
    } catch (error) {
      console.error(error);
       setReload(false)
    }
  };
  const hnbOffer = async () => {
    try {
      if (validateAll()) {
          const hasFinancing = contingencyList?.some(
  (item) => item.contingencyType === "FINANCING"
);

const filteredContingencyList = hasFinancing
  ? contingencyList
  : contingencyList?.filter((item) => item.contingencyType !== "FINANCING");
        const payload = {
          offerId: id,
          hnbOfferAmount: offerAmount,
          offerDeposit: deposit,
          closingDays: Number(closingDays),
          sellerContributionList: sellerContributions,
          offerExpiryDays: Number(validFor),
          contingencyList: filteredContingencyList?.map((item) => ({
    comment: item.comment,
    expiryDays: item.expiryDays ?? null,
    contingencyType: item.contingencyType,
  })) || [],
        };
        const wj = item?.activeOffer?.offerId;
      const payload1 = {
        offerId: item?.activeOffer?.offerId,
        activeOffer: item?.activeOffer?.offerId,
        propertyId: item?.propertyDetail?.propertyId,
        buyerDetail: `${item?.buyerDetail?.emailId}|${item?.buyerDetail?.firstName}|${item?.buyerDetail?.lastName}`,
      };
         const hnbData = await hnbOfferApi(payload);

      if(hnbData?.status==="SUCCESS")
        {
          trackApiCall({
            eventName: "place_hnb_success",
            eventCategory: "My Offers",
            eventSource: "on confirm click success",
            eventLabel: `Offer Id: ${id}`,
          })

          const resp = await getPropertyOffer({ id:wj, payload:payload1 });
          if(resp.status === "SUCCESS"){
          handleClose()
            // toast.success("Offer was countered Successfully");
             setReload(true)
        }else{
          console.error(resp,'error while submitting');
           setReload(false)

        }

      }else{
          console.error(hnbData,'error while submitting');
           setReload(false)

        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getOfferDetails = async (id) => {
    try {
      setLoading(true);
      const data = await getOfferDetailsApi({ id });
      setData(data?.offerCounterDetails);
      setOfferAmount(data?.offerCounterDetails?.defaultCounterAmount);
      setDeposite(data?.offerCounterDetails?.defaultOfferDeposit);
      setClosingDays(data?.offerCounterDetails?.defaultClosingDays);
      setValidFor("");
      setSellerContributions(
        data?.offerCounterDetails?.negotiationContributionList || []
      );
      setContingencyList(data?.contingencyList || [])
      setTechnologyFee(data?.offerCounterDetails?.technologyFees);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getHnBDetails = async (id) => {
    try {
      setLoading(true);

      const data = await getHnBApi({ id });
      setData(data?.offerCounterDetails);
      setOfferAmount(data?.offerCounterDetails?.defaultCounterAmount);
      setDeposite(data?.offerCounterDetails?.defaultOfferDeposit);
      setClosingDays(data?.offerCounterDetails?.defaultClosingDays);
      setValidFor("");
      setSellerContributions(
        data?.offerCounterDetails?.negotiationContributionList || []
      );
      setTechnologyFee(data?.offerCounterDetails?.technologyFees);
      setContingencyList(data?.contingencyList || [])

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (type === "counter") {
      getOfferDetails(id);
    } else {
      getHnBDetails(id);
    }
  }, [id]);

  const formatCurrency = (value) => {
    if (value === "" || isNaN(value)) return "";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Number(value));
  };
  const validateAll = () => {
    validateField("offerAmount", offerAmount);
    validateField("deposit", deposit);
    validateField("closingDays", closingDays);
    validateField("validFor", validFor);

    const hasErrors = [offerAmount, deposit, closingDays, validFor].some(
      (val) => !val
    );
    return !hasErrors;
  };

  const offerEmdFn = async () => {
    try {
      const d = await offerEmd({
        amount: offerAmount,
        listingId: data?.listingId,
      });
      setTechnologyFee(data?.technologyFees);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (offerAmount) {
      offerEmdFn();
    }
  }, [offerAmount]);
//   useEffect(() => {
//   const options = renderDays(data?.minClosingDays, data?.maxClosingDays);
//   const defaultVal = data?.defaultClosingDays?.toString();

//   const isDefaultAvailable = options.includes(defaultVal);
// console.log(isDefaultAvailable,'def',defaultVal,options);

//   setClosingDays(isDefaultAvailable ? defaultVal : "");
// }, [data]);

const handleContingencyDayChange = (type, value) => {
  setContingencyList((prev) =>
    prev.map((item) =>
      item.contingencyType === type
        ? {
            ...item,
            expiryDays: value,
            comment: `Buyer requests ${value} days, from date Seller approves Buyer offer, to secure financing.`
          }
        : item
    )
  );
};
useEffect(() => {
  if (data?.contingencyList?.length>0) {
    setContingencyList(data.contingencyList || []);
  }
}, [data?.contingencyList]);

  return (
    <Modal show={show} onHide={handleClose} size="md">
      <Modal.Header closeButton className="license-title">
        <Modal.Title className="text-white roboreg">
          {type === "counter" ? "Offer Counter" : "Highest & Best"}{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        {loading ? (
          <ShimmerContentBlock
            title
            text
            cta
            thumbnailWidth={180}
            thumbnailHeight={100}
          />
        ) : (
          <>
            <div className="">
              <p className="counter-offer-heading">Offer Information</p>
              <p className="min-offer-price-couner ">
                Min Offer Price{" "}
                <b className="min-price-val">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(data?.minCounterAmount)}
                </b>
              </p>
              <div className="counter-offer-form p-3">
                <div className="counter-offer-form-input row">
                  <label
                    className="counter-offer-key col-6"
                    htmlFor="counter-offer"
                  >
                    {type === "counter"
                      ? "Counter Offer Amount"
                      : "H & B Offer Amount"}
                  </label>
                  <div className="col-6">
                    <input
                      className={`${
                        error.offerAmount ? "error-border" : ""
                      } form-control fs-12 input-type-offer`}
                      value={
                        isOfferAmountFocused
                          ? offerAmount
                          : offerAmount
                          ? formatCurrency(offerAmount)
                          : ""
                      }
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "");
                        setOfferAmount(value);
                      }}
                      onFocus={() => setIsOfferAmountFocused(true)}
                      onBlur={() => {
                        validateField("offerAmount", offerAmount);
                        setIsOfferAmountFocused(false);
                      }}
                    />
                    {error.offerAmount && (
                      <small className="error-text-offer">
                        {error.offerAmount}
                      </small>
                    )}
                  </div>
                </div>
                <div className="counter-offer-form-input row ">
                  <label
                    className="counter-offer-key col-6"
                    htmlFor="counter-offer"
                  >
                    Offer Deposit
                  </label>
                  <div className="col-6">
                    <input
                      className={`${
                        error.deposit ? "error-border" : ""
                      } form-control fs-12  input-type-offer`}
                      value={
                        isDepositFocused
                          ? deposit
                          : deposit
                          ? formatCurrency(deposit)
                          : ""
                      }
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "");
                        setDeposite(value);
                      }}
                      onFocus={() => setIsDepositFocused(true)}
                      onBlur={() => {
                        validateField("deposit", deposit);
                        setIsDepositFocused(false);
                      }}
                    />
                    {error.deposit && (
                      <small className="error-text-offer">
                        {error.deposit}
                      </small>
                    )}
                  </div>
                </div>
                <div className="counter-offer-form-input row">
                  <label
                    className="counter-offer-key col-6"
                    htmlFor="counter-offer"
                  >
                    Closing Days
                  </label>
                  <div className="col-6 ">
                    <div className="d-flex">
                      <select
                        className={`${
                          error.closingDays ? "error-border" : ""
                        } form-select fs-12  input-type-offer w-50`}
                        value={closingDays}
                        onChange={(e) => setClosingDays(e.target.value)}
                        onBlur={() => validateField("closingDays", closingDays)}
                      >
                        <option value="">Select</option>
                        {renderDays(
                          data?.minClosingDays,
                          data?.maxClosingDays,
                          ""
                        )}
                      </select>{" "}
                      <span className="days-counter">days</span>{" "}
                    </div>
                    {error.closingDays && (
                      <small className="error-text-offer">
                        {error.closingDays}
                      </small>
                    )}
                  </div>
                </div>
                <div className="counter-offer-form-input row">
                  <label
                    className="counter-offer-key col-6"
                    htmlFor="counter-offer"
                  >
                    Valid For
                  </label>
                  <div className="col-6">
                    <div className="d-flex">
                      <select
                        className={`${
                          error.validFor ? "error-border" : ""
                        } form-select w-50 fs-12  input-type-offer`}
                        value={validFor}
                        onChange={(e) => setValidFor(e.target.value)}
                        onBlur={() => validateField("validFor", validFor)}
                      >
                        <option value="">Select</option>
                        {renderDays(
                          data?.minOfferExpiryDays,
                          data?.maxOfferExpiryDays,
                          ""
                        )}
                      </select>{" "}
                      <span className="days-counter">days</span>
                    </div>
                    {error.validFor && (
                      <small className="error-text-offer">
                        {error.validFor}
                      </small>
                    )}
                  </div>
                </div>
                <div className="counter-offer-form-input row">
                  <label
                    className="counter-offer-key col-6"
                    htmlFor="counter-offer"
                  >
                    Technology Fee
                  </label>
                  <span className="col-6 fs-12" >{formatCurrency(technologyFee)}</span>
                </div>
              </div>
              {
               ( data?.contingencyList && data?.contingencyList?.length>0 ) && (
                <>
                <p className="counter-offer-heading">
                  Seller Contingencies
                </p>
                {
                  (data?.contingencyList?.length===2 || data?.contingencyList?.length===1)?<>
                {

                  data?.contingencyList?.[0]?.contingencyType==="FINANCING"?
                  <>
                  {contingencyList
  ?.filter((item) => item.contingencyType === "FINANCING")
  .map((item, index) => {
    const parts = item.comment.split(/(\d+\s+days)/); // Split around "16 days"

    return (
      <p key={index} className="counter-offer-key px-2 fs-12-imp">
        {parts[0]}
        <select
          className="form-select d-inline w-auto mx-1 input-type-offer h-100 fs-12"
          value={item.expiryDays}
          onChange={(e) => handleContingencyDayChange("FINANCING", e.target.value)}
        >
          {[...Array(data?.maxOfferExpiryDays + 1).keys()].slice(1).map((day) => (
            <option key={day} value={day}>
              {day}
            </option>
          ))}
        </select>
        {parts[2]}
      </p>
    );
  })}</>:
                  <p className="counter-offer-key px-2 fs-12-imp">{data?.contingencyList?.[0]?.comment}</p>
                }
                  {
                    data?.contingencyList?.[1] &&  <p className="counter-offer-key px-2 fs-12-imp">{data?.contingencyList?.[1]?.comment}</p>
                  }

                  </>:<>
                  {contingencyList
  ?.filter((item) => item.contingencyType === "FINANCING")
  .map((item, index) => {
    const parts = item.comment.split(/(\d+\s+days)/); // Split around "16 days"

    return (
      <p key={index} className="counter-offer-key px-2 fs-12-imp">
        {parts[0]}
        <select
          className="form-select d-inline w-auto mx-1 input-type-offer h-100 fs-12"
          value={item.expiryDays}
          onChange={(e) => handleContingencyDayChange("FINANCING", e.target.value)}
        >
          {[...Array(data?.maxOfferExpiryDays + 1).keys()].slice(1).map((day) => (
            <option key={day} value={day}>
              {day}
            </option>
          ))}
        </select>
        {parts[2]}
      </p>
    );
  })}

                   <p className="counter-offer-key px-2 fs-12-imp">{data?.contingencyList?.[1]?.comment}</p>
                  {
                    data?.contingencyList?.[1] &&  <p className="counter-offer-key px-2 fs-12-imp">{data?.contingencyList?.[2]?.comment}</p>
                  }

                  </>
                }
                </>
               )
              }
              <div className="counter-seller-contri">

              </div>
              <div className="counter-seller-contri">
                <p className="counter-offer-heading">Seller Contributions</p>
                <div className="p-2">
                <table className="table">
                  <thead className="thead-counter">
                    <tr>
                      <th className="table-offer-counter">Description</th>
                      <th className="table-offer-counter">Amount</th>
                      <th className="table-offer-counter">Notes</th>
                      <th className="table-offer-counter"> Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sellerContributions?.map((item, idx) => (
                      <>
                        <tr key={idx} className="thead-counter">
                          <td className="counter-offer-key w-165">{item.description || item?.contributionDesc}</td>
                          <td className="counter-offer-key">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }).format(item.amount || item.contributionAmount)}
                          </td>
                          <td className="counter-offer-key">{item.notes || item.additionalNote}</td>
                          <td className="counter-offer-key">
                            <button
                              className="btn  p-0"
                              onClick={() => {
                               setShowDelete(idx)
                               trackButtonClick({
                                  eventName: "contribution_delete_click",
                                  eventCategory: "My Offers",
                                  eventSource: "on delete icon click",
                                  eventLabel: `Offer Id - ${id}`,
                                  eventParams: { offer_type: type },
                                });
                              }}
                            >
                              🗑
                            </button>
                          </td>
                        </tr>
                        {showDelete === idx && (
        <tr>
          <td colSpan="4" style={{ textAlign: "right" }}>
            <div className="delete-div-offer">
              Are you sure you want to delete?
              <button className="confirmButtons-yn" onClick={() => handleRemoveContribution(idx)}>
                yes
              </button>
              <button className="confirmButtons-yn" onClick={() => {
                setShowDelete(null)
                 trackButtonClick({
                    eventName: "contribution_delete_cancel",
                    eventCategory: "My Offers",
                    eventSource: "on no click",
                    eventLabel: `Offer Id - ${id}`,
                    eventParams: { offer_type: type },
                  });
                }}>
                no
              </button>
            </div>
          </td>
        </tr>
      )}
                      </>
                    ))}
                  </tbody>
                </table>

                <div className="mb-2 fw-bold table-offer-counter p-2">
                  Total Contributions:  <span className="pl40">$
                  {sellerContributions?.reduce(
                      (acc, item) =>
                        acc +
                        Number(item.amount || item?.contributionAmount || 0),
                      0
                    )
                    .toLocaleString()}
                    </span>
                </div>

                <div className="d-flex gap-2 justify-content-between  align-items-start">
                  <select
                    className={`form-select ${
                      showError && !newContribution.contributionDesc
                        ? "error-border"
                        : ""
                    } input-type-offer h-100 fs-12`}
                    value={newContribution.contributionDesc}
                    onChange={(e) =>{
                     const selectedType = e.target.value;
  const selectedItem = data?.sellerContributionList?.find(
    (item) => item.contributionDesc === selectedType
  );

  if (selectedItem) {
    setNewContribution({
      ...newContribution,
      contributionDesc: selectedItem.contributionDesc,
      contributionType: selectedItem.contributionType,
    });
  }}
                    }
                  >
                    <option value="">Select</option>
                    {data?.sellerContributionList
                      ?.filter(
                        (item) =>
                          !sellerContributions?.some(
                            (existing) =>
                              existing.contributionDesc ===
                                item.contributionDesc ||
                              existing.description === item.contributionDesc
                          )
                      )
                      .map((item) => (
                        <option
                          key={item.contributionType}
                          value={item.contributionDesc}
                        >
                          {item.contributionDesc}
                        </option>
                      ))}
                  </select>
                 <input
  className="form-control input-type-offer fs-12 h-100"
  type="text"
  name="amount"
  placeholder="Enter Amount"
  value={
    isAmountFocused
      ? newContribution.contributionAmount
      : newContribution.contributionAmount
      ? formatCurrency(newContribution.contributionAmount)
      : ""
  }
  onFocus={() => {
    setIsAmountFocused(true);
    setNewContribution((prev) => ({
      ...prev,
      contributionAmount: prev.contributionAmount?.replace(/,/g, "") || "",
    }));
  }}
  onChange={(e) => {
    const raw = e.target.value.replace(/[^0-9.]/g, "");
    setNewContribution({
      ...newContribution,
      contributionAmount: raw,
    });
  }}
  onBlur={() => {
    validateField(
      "amount",
      newContribution.contributionAmount,
      newContribution?.contributionType
    );
    setIsAmountFocused(false);
  }}
/>
                  <input
                    className="form-control input-type-offer fs-12 input-type-offer h-75"
                    type="text"
                    name="notes"
                    placeholder="Additional Notes"
                    value={newContribution.additionalNote}
                    onChange={(e) =>
                      setNewContribution({
                        ...newContribution,
                        additionalNote: e.target.value,
                      })
                    }
                  />

                  <button
                    className="btn btn-sm btn-dark"
                    onClick={handleAddContribution}
                  >
                    Add
                  </button>
                </div>

                {showError && (
                  <div className="error-text-offer mt-1">
                    Please Enter valid Contributions
                  </div>
                )}
                   {error.amount && (
                      <small className="error-text-offer fs-12">{error.amount}</small>
                    )}

                </div>

              </div>
            </div>

            <div className="d-flex justify-content-center mt-3">
              <button
                className="mx-2 yes-btn"
                onClick={() =>
                  type === "counter" ? counterOffer() : hnbOffer()
                }
              >
                Submit
              </button>
              <button className="no-btn" onClick={() => {
                trackButtonClick({
                  eventName: "offer_cancel_click",
                  eventCategory: "My Offers",
                  eventSource: "on cancel button click",
                  eventLabel: `Offer Id - ${id}`,
                  eventParams: { offer_type: type },
                });
                handleClose();
                }}>
                Cancel
              </button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CounterOffer;
